import { getApp, getApps, initializeApp } from 'firebase/app';
import { getPerformance } from 'firebase/performance';

import { environment } from '../../environments/environment';

export const perf = (() => {
  const firebaseConfig = {
    apiKey: environment.FIREBASE_API_KEY,
    authDomain: environment.FIREBASE_AUTH_DOMAIN,
    projectId: environment.FIREBASE_PROJECT_ID,
    storageBucket: environment.FIREBASE_STORAGE_BUCKET,
    messagingSenderId: environment.FIREBASE_MESSAGING_SENDER_ID,
    appId: environment.FIREBASE_APP_ID,
    measurementId: environment.FIREBASE_MEASUREMENT_ID,
  };

  function hasFirebaseWebConfig(config: typeof firebaseConfig) {
    return Boolean(config.apiKey && config.appId && config.projectId);
  }

  const firebaseApp = (() => {
    if (!hasFirebaseWebConfig(firebaseConfig)) {
      return null;
    }

    if (getApps().length) {
      return getApp();
    }

    return initializeApp(firebaseConfig);
  })();

  if (!firebaseApp) {
    return null;
  }
  try {
    return getPerformance(firebaseApp);
  } catch {
    return null;
  }
})();
